import { FC } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Box, Typography } from '@mui/material';

import EmailIcon from '../../assets/icons/Emails, Letter, Mail.png';
import AuthWrapper from '../../common/AuthWrapper';
import CustomSocialMediaButton from '../../common/CustomSocialMediaButton';
import { useIsMobile } from '../../hooks/useWindowWidth';
import GoogleButton from '../../common/GoogleButton/GoogleButton';
import { isInviteFlowEnabled } from '../../constants/inviteFlow';

import styles from './SignUp.module.scss';

const SignUp: FC = () => {
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const isInviteFlow = isInviteFlowEnabled();

  return (
    <AuthWrapper btnName="Sign In">
      <Box className={styles.signUpWrapper}>
        <Box className={styles.signUpContent}>
          <Typography
            variant={`${isMobile ? 'h6Bold' : 'h5Bold'}`}
            className={styles.title}
          >
            Sign Up
          </Typography>
          <CustomSocialMediaButton
            customStyle={styles.emailButton}
            text="Continue with Email"
            icon={EmailIcon}
            onClick={() => navigate('/create-account')}
          />
          {!isInviteFlow && (
            <>
              <Box className={styles.signUpText}>
                <Box className={styles.dividerLine}></Box>
                <Typography
                  variant="h12"
                  className={styles.dividerText}
                >
                  OR
                </Typography>
                <Box className={styles.dividerLine}></Box>
              </Box>
              <Box className={styles.socialMediaButtons}>
                <GoogleButton />
              </Box>
            </>
          )}
          <Box className={styles.signInQuestion}>
            <Typography
              variant="h11"
              className={styles.signInQuestionText}
            >
              Already have an account?
            </Typography>
            <Link
              to="/"
              className={styles.signInLink}
            >
              <Typography variant="h11Semibold">Log In</Typography>
            </Link>
          </Box>
        </Box>
        <Box className={styles.termsAndConditions}>
          <Typography
            variant="h11"
            sx={{ textAlign: 'center' }}
          >
            By signing up, you understand and agree with TravGenius'
          </Typography>
          <Typography variant="h11">
            <a
              href="/terms-privacy/TravGenius Terms and Conditions MAIN.pdf"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: '#222B3A' }}
            >
              Terms & Conditions
            </a>
            <span> and </span>
            <a
              href="/terms-privacy/TravGenius Privacy Policy (GDPR & CCPA) MAIN.pdf"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: '#222B3A' }}
            >
              Privacy Policy
            </a>
          </Typography>
        </Box>
      </Box>
    </AuthWrapper>
  );
};

export default SignUp;
